// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLumera700Head_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4918 4.32306C18.3207 2.47228 15.4797 1 12 1C8.52034 1 5.6793 2.47228 5.50816 4.32306L5.5 4.325V13.6901L1 16.2882V18.5976L5.5 15.9995V16.675L5.50816 16.6769C5.5654 17.296 5.92135 17.8727 6.5 18.3661V19.5C6.5 21.433 8.96243 23 12 23C15.0376 23 17.5 21.433 17.5 19.5V18.3661C18.0786 17.8727 18.4346 17.296 18.4918 16.6769L18.5 16.675V15.9999L23 18.598V16.2886L18.5 13.6905V4.325L18.4918 4.32306ZM15.648 3.78607C16.3061 4.14046 16.4582 4.41817 16.4917 4.5H16.5V16.5H16.4917C16.4582 16.5818 16.3061 16.8595 15.648 17.2139C14.8164 17.6617 13.5302 18 12 18C10.4698 18 9.18362 17.6617 8.352 17.2139C7.69386 16.8595 7.54183 16.5818 7.50825 16.5H7.5V4.5H7.50825C7.54183 4.41817 7.69386 4.14046 8.352 3.78607C9.18362 3.33828 10.4698 3 12 3C13.5302 3 14.8164 3.33828 15.648 3.78607ZM15.5 19.4498C15.4504 19.4669 15.4004 19.4836 15.3499 19.5H15.5V19.4498ZM8.65074 19.5002C9.62889 19.8175 10.7749 20 12 20C13.2251 20 14.3718 19.8173 15.3499 19.5H15.5C15.4999 19.5463 15.4663 19.8733 14.8153 20.2876C14.1871 20.6873 13.1972 21 12 21C10.8028 21 9.81286 20.6873 9.18466 20.2876C8.53372 19.8733 8.5001 19.5465 8.5 19.5002H8.65074ZM8.65074 19.5002C8.60025 19.4838 8.54958 19.4669 8.5 19.4498V19.5002H8.65074Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLumera700Head is a generated icon component.
 */
let IconMedLumera700Head = IconMedLumera700Head_1 = class IconMedLumera700Head extends IconBaseElement {
    render() {
        return html `${IconMedLumera700Head_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLumera700Head.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLumera700Head = IconMedLumera700Head_1 = __decorate([
    customElement('zui-icon-med-lumera-700-head')
], IconMedLumera700Head);
export { IconMedLumera700Head };
